module.exports = __webpack_public_path__ + "static/media/emiliano_buendia.af4484c4.jpg";